import startCase from "lodash/startCase";

export default function formatProjectTypeName(name) {
  return name === name.toLowerCase() ? startCase(name) : name;
}
